import { ReactNode } from 'react';
import { Progress, Tooltip, enums } from 'edrolo-ui';
import { ExamSitting } from '../../../../types/ExamSitting';

interface StudentProgressProps {
  examSitting: ExamSitting | null | undefined;
}

export const StudentProgress = ({ examSitting }: StudentProgressProps) => {
  let tip: ReactNode;
  let numeratorPercentage = 0;

  if (!examSitting) {
    tip = <span>Exam has not been started yet.</span>;
    numeratorPercentage = 0;
  } else if (examSitting.submitted_ts) {
    tip = <span>Exam has been submitted.</span>;
    numeratorPercentage = 100;
  } else if (examSitting.started_ts) {
    tip = <span>Exam has been started.</span>;
    numeratorPercentage = 50;
  }

  return (
    <Tooltip tip={tip}>
      <Progress.Circle
        numerator={numeratorPercentage}
        denominator={100}
        color={enums.ColorHue.TEAL}
        size={enums.Size.LARGE}
      />
    </Tooltip>
  );
};
